import {
  createRouter,
  createWebHashHistory,
} from 'vue-router';

import Home from '../views/Home.vue';
import Editor from '../views/Editor.vue';
import Ceshi from '../views/Ceshi.vue';

const routes = [
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/editor',
    name: 'editor',
    component: Editor
  },
  {
    path: '/ceshi',
    name: 'ceshi',
    component: Ceshi
  }

]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
